
import actionTypes from './actionTypes';

const initialState = {
    openModal: false,
    errorMessage: null
};

const actions = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.MODAL_OPEN:
            return {
                ...state,
                openModal: true,
                errorMessage: action.newValue
            };
        case actionTypes.MODAL_CLOSE:
            return {
                ...state,
                openModal: false,
                errorMessage: null
            };
        default:
            return state;
    }
};

export default actions;
